import styles from './ToggleSwitch.module.css'

type ToggleSwitchProps = {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  label?: string
  className?: string
}

export default function ToggleSwitch({ checked, onChange, disabled = false, label, className }: ToggleSwitchProps) {
  return (
    <label className={`${styles.wrapper} ${className || ''} ${disabled ? styles.disabled : ''}`.trim()}>
      <input
        type="checkbox"
        className={styles.input}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <span className={`${styles.track} ${checked ? styles.trackOn : styles.trackOff}`}></span>
      <span className={`${styles.thumb} ${checked ? styles.thumbOn : styles.thumbOff}`}></span>
      {label ? <span className={styles.label}>{label}</span> : null}
    </label>
  )
}
